export const openSuseBgMobile = require("./openSuseBgMobile.png");
export const openSuseBgTablet = require("./openSuseBgTablet.png");
export const openSuseBg = require("./openSuseBg.png");
export const openSuseDevices = require("./opensuse_overlay-fs8.png");
